import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Space, Stack, Text } from '@mantine/core'
import { Alert, Anchor } from '@/components/Elements'
import { AuthCard } from '@/features/auth/components/Elements'
import { useForgotPasswordMutation } from '@/features/auth/store'
import { PATH } from '@/routes/const'
import { ForgotPasswordForm, FormValues } from './ForgotPasswordForm'

export const ForgotPasswordContainer = () => {
  const { t } = useTranslation()

  const [forgotPassword] = useForgotPasswordMutation()

  const [success, setSuccess] = useState<string | null>(null)

  const handleSubmit = async (values: FormValues) => {
    setSuccess(null)

    await forgotPassword(values).unwrap()

    setSuccess(t('forgot_password.success'))
  }

  return (
    <AuthCard title={t('reset_password')}>
      <Stack spacing="xs" align={'flex-start'}>
        <Text>{t('forgot-password.hint')}</Text>
      </Stack>

      <Space h={'xl'} />

      {success && (
        <Alert type={'success'} mb={'sm'}>
          {success}
        </Alert>
      )}

      <ForgotPasswordForm onSubmit={handleSubmit} />

      <Space h={'xl'} />

      <Stack spacing="xs" align={'flex-start'}>
        <Anchor component={Link} to={`/${PATH.LOGIN}`}>
          <Text tt="capitalize" fw={'600'}>
            {t('back_to_login_page')}
          </Text>
        </Anchor>
      </Stack>
    </AuthCard>
  )
}
